import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { endDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium } = breakpoints;

const S = {};

S.Benefits = styled.ul`
  display: grid;
  grid-gap: 1.5rem;
  text-align: initial;
  margin-block: 1.4rem 2.25rem;

  @media (${widthSmall}) {
    margin-${endDirection}: 2.1875rem;
    margin-block: 2.2rem 2.5rem;
    grid-gap: 1.45rem;
  }

  @media (${widthMedium}) {
    margin-block: 2.5rem 3.5rem;
  }
`;

export default S;
